export const supportalTypes = {
  SET_FILTERED_USERS: "SET_FILTERED_USERS",
  SET_COUNTS: "SET_COUNTS",
  SET_PAGE: "SET_PAGE",
  SET_SEARCH_BY: "SET_SEARCH_BY",
  SET_SORT_BY: "SET_SORT_BY",
  SET_ORDER_BY: "SET_ORDER_BY",
  SET_FILTER_BY: "SET_FILTER_BY",
  SET_FILTER_BY_REASON: "SET_FILTER_BY_REASON",
  SET_FILTER_BY_ADDITIONAL_ACCOUNTS: "SET_FILTER_BY_ADDITIONAL_ACCOUNTS",
  SET_INCLUDE_TAGS: "SET_INCLUDE_TAGS",
  SET_EXCLUDE_TAGS: "SET_EXCLUDE_TAGS",
  SET_FILTER_BY_MANUAL_REVIEW: "SET_FILTER_BY_MANUAL_REVIEW",
  // SET_FILTER_BY_FRAUD_REVIEW: "SET_FILTER_BY_FRAUD_REVIEW"
};

export const setFilteredUsers = filteredUsers => ({
  type: supportalTypes.SET_FILTERED_USERS,
  payload: { filteredUsers }
});

export const setCounts = counts => ({
  type: supportalTypes.SET_COUNTS,
  payload: { counts }
});

export const setPage = page => ({
  type: supportalTypes.SET_PAGE,
  payload: { page }
});

export const setSearchBy = searchBy => ({
  type: supportalTypes.SET_SEARCH_BY,
  payload: { searchBy }
});

export const setSortBy = sortBy => ({
  type: supportalTypes.SET_SORT_BY,
  payload: { sortBy }
});

export const setOrderBy = orderBy => ({
  type: supportalTypes.SET_ORDER_BY,
  payload: { orderBy }
});

export const setFilterBy = filterBy => ({
  type: supportalTypes.SET_FILTER_BY,
  payload: { filterBy }
});


export const setFilterByReason = filterByReason => ({
  type: supportalTypes.SET_FILTER_BY_REASON,
  payload: { filterByReason }
});


export const setFilterByAdditionalAccounts = filterByAdditionalAccounts => ({
  type: supportalTypes.SET_FILTER_BY_ADDITIONAL_ACCOUNTS,
  payload: { filterByAdditionalAccounts }
});

export const setIncludeTags = tags => ({
  type: supportalTypes.SET_INCLUDE_TAGS,
  payload: { includeTags: tags }
});

export const setExcludeTags = tags => ({
  type: supportalTypes.SET_EXCLUDE_TAGS,
  payload: { excludeTags: tags }
});

export const setFilterByManualReview = filterByManualReview => ({
  type: supportalTypes.SET_FILTER_BY_MANUAL_REVIEW,
  payload: { filterByManualReview }
});

// export const setFilterByFraudReview = filterByFraudReview => ({
//   type: supportalTypes.SET_FILTER_BY_FRAUD_REVIEW,
//   payload: { filterByFraudReview }
// });